// extracted by mini-css-extract-plugin
export default {"AttachmentView":"XICjTMhoFjMXji5JUV6W"};